export function getAbTests(params = {}) {
  return {
    method: 'GET',
    url: '/v1/ab-test',
    params
  };
}
